<template>
  <div class="w-full">
    <!-- header section profile pic and time ago  -->
    <div>
      <div v-if="isAbove" class="flex justify-between items-center" data-tip="Edit Segment">
        <section>
          <button
            v-if="isLast"
            type="button"
            @click="handleNextCallback"
            class="btn btn-outline ml-5"
          >
            Older
          </button>
          <button
            v-if="isFirst"
            type="button"
            @click="handlePrevCallback"
            class="btn btn-outline ml-5"
          >
            Newer
          </button>
        </section>
        <section class="flex items-center">
          <font-awesome-icon
          class="reaction text-gray-600 mr-5"
          size="lg"
          :icon="['fas', 'heart']"
          @click="importModal()"
        />
        {{tweetInfo ? tweetInfo.public_metrics.like_count : 0}}
        </section>
      </div>
      <hr class="my-3" />
    </div>
    <div class="flex items-center">
      <!-- avatar of user from tweet account -->
      <a
        :href="`https://twitter.com/${tweetInfo.user.name}`"
        target="_blank"
      >
        <div class="avatar">
          <div class="w-24 rounded-full">
            <img :src="tweetInfo.user.profile_image_url" />
          </div>
        </div>
      </a>
      <div class="ml-8 mt-2">
        <a
          :href="`https://twitter.com/${tweetInfo.user.username}`"
          target="_blank"
        >
          <h5 class="font-semibold text-xl">{{ tweetInfo.user.name }}</h5>
        </a>
        <p class="-mt-2 text-gray-600">
          <a
            :href="`https://twitter.com/${tweetInfo.user.username}`"
            target="_blank"
          >
            @{{ tweetInfo.user.username }}
          </a>
          -

          <span
            >{{
              (tweetInfo.user.public_metrics.followers_count).toLocaleString('en-US')
            }}
            followers</span
          >
        </p>
      </div>
      <div class="ml-auto text-gray-600 tracking-wider">
        <a
          :href="`https://twitter.com/${tweetInfo.user.username}/status/${tweetInfo.id}`"
          target="_blank"
        >
          {{ tweetInfo.created_at | moment }}
        </a>
      </div>
    </div>
    <!-- tweet mssg section  -->
    <div class="scrollbar-hide py-5 text-xl min-h-50">
      <!-- tweet text  -->
      <section v-html="twitterText"></section>
      <!-- {{
          tweetInfo.truncated
            ? tweetInfo.text.replace(tweetInfo.entities.urls[0].url, '')
            : tweetInfo.text
        }} -->
      <div v-if="tweetInfo.entities">
        <a
          v-for="(urlData, index) in tweetInfo.entities.urls"
          :key="index + 'url'"
          :href="urlData.url"
          target="_blank"
          >{{ urlData.url }}</a
        >
      </div>
      <div
        v-if="tweetInfo.entities && tweetInfo.entities.urls"
        class="relative"
      >
        <!-- <spinner
          :loading="
            tweetInfo.entities &&
            tweetInfo.entities.urls.length &&
            !urlData.length
          "
        /> -->
        <section
          v-for="(urlDetails, index) in urlData"
          :key="index"
          class="shadow-md rounded-md p-2 mt-5"
        >
          <!-- if provide is not twitter  -->
          <section class="flex" v-if="urlDetails.provider !== 'Twitter'">
            <!-- img -->
            <div class="h-24 mr-2 flex-none">
              <img
                :src="urlDetails.image"
                :alt="urlDetails.title"
                class="w-full h-full rounded-md object-contain"
              />
            </div>
            <!-- details  -->
            <div>
              <a
                :href="urlDetails.url"
                target="_blank"
                class="text-base font-medium"
                >{{ urlDetails.title }}</a
              >
              <p class="text-sm">{{ urlDetails.description }}</p>
            </div>
          </section>
          <!-- if provide is twitter  -->
          <section
            class=""
            v-if="urlDetails.provider === 'Twitter' && urlDetails.user"
          >
            <section class="flex items-center">
              <div
                v-if="urlDetails.provider === 'Twitter'"
                class="h-10 w-10 rounded-full mr-2 flex-none"
              >
                <img
                  :src="urlDetails.user.profile_image_url_https"
                  :alt="urlDetails.user.name"
                  class="w-full h-full object-contain rounded-full"
                />
              </div>
              <p class="text-sm mb-0 mr-2">{{ urlDetails.user.name }}</p>
              <a
                :href="urlDetails.user.name"
                target="_blank"
                class="text-base font-medium mr-5"
                >@{{ urlDetails.user.name }}</a
              >
              <a
                class="text-base"
                :href="`https://twitter.com/${urlDetails.user.name}/status/${tweetInfo.id_str}`"
                target="_blank"
              >
                {{ urlDetails.created_at | moment }}
              </a>
            </section>
            <!-- description-->
            <p class="text-base">
              {{ urlDetails.text }}
            </p>
          </section>
          <section class="flex flex-wrap" v-if="urlDetails.provider === 'Twitter'">
            <a
              v-for="(data, index) in tweetInfo.entities.urls"
              :key="index + 'url'"
              :href="data.expanded_url"
              target="_blank"
              class="text-base"
            >
              {{ data.expanded_url }}
            </a>
          </section>
        </section>
      </div>
      <!-- tweet media  -->
      <section
        v-if="
          tweetInfo.media &&
          tweetInfo.media.length
        "
        class="mt-5"
      >
        <div
          class="mt-5"
          v-for="(mediaData, index) in tweetInfo.media"
          :key="index"
        >
          <img :src="mediaData.url" class="object-contain h-56" />
        </div>
      </section>
    </div>
    <hr class="my-3" />
    <div v-if="!isAbove" class="flex justify-between" data-tip="Edit Segment">
      <section>
        <button
          v-if="isLast"
          type="button"
          @click="handleNextCallback"
          class="btn btn-outline ml-5"
        >
          Older
        </button>
        <button
          v-if="isFirst"
          type="button"
          @click="handlePrevCallback"
          class="btn btn-outline ml-5"
        >
          Newer
        </button>
      </section>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axiosApi from '../../services/inteceptor';
import store from '@/store';
import utils from '../../services/utils';
// import spinner from '@/components/spinner.vue';

const API_USER_INFO = `${utils.svcUrl()}connect`;

export default {
  // components: { spinner },
  name: 'TweetRenderLeft',
  layout: 'admin',
  store,
  props: [
    'tweetInfo',
    'isLast',
    'isFirst',
    'handlePrevCallback',
    'handleNextCallback',
  ],
  data() {
    return {
      activityData: {},
      twitterText: '',
      urlData: [],
      isAbove: false,
    };
  },
  computed: {
    userDetails() {
      return this.$store.state?.userDetails;
    },
  },
  mounted() {
    this.changeTweetText();
    this.fetchMeta();
    this.isAbove = this.userDetails?.configureInfo?.connectTabBtnShowAbove;
  },
  watch: {
    tweetInfo(newInfo, oldInfo) {
      if (newInfo !== oldInfo) {
        console.log(this.tweetInfo, 'tweetInfo');
        this.activityData = this.tweetInfo;
        this.changeTweetText();
        this.urlData = [];
        this.fetchMeta();
      }
    },
    userDetails(newVal) {
      this.isAbove = newVal?.configureInfo?.connectTabBtnShowAbove;
    },
  },
  methods: {
    changeTweetText() {
      let tempText = this.tweetInfo.text;
      if (this.tweetInfo.entities) {
        const { entities } = this.tweetInfo;
        if (this.tweetInfo.entities.media) {
          tempText = tempText.replace(this.tweetInfo.entities.media[0].url, '');
        }
        if (this.tweetInfo?.entities?.urls?.length) {
          tempText = tempText.replace(this.tweetInfo.entities.urls[0].url, '');
        }
        if (entities.mentions) {
          entities.mentions.forEach((data) => {
            tempText = tempText.replace(
              `@${data?.username}`,
              `<a href="https://twitter.com/${data?.username}" target="_blank">@${data?.username}</a>`,
            );
          });
        }
      }
      this.twitterText = tempText.replace(/\n/g, '<br />');
    },
    async fetchMeta() {
      try {
        if (this.tweetInfo?.entities?.urls?.length) {
          const allEntities = this.tweetInfo?.entities?.urls.filter((data) => data.expanded_url?.split('/')[5] !== this.tweetInfo?.id);
          const response = await axiosApi.post(
            `${API_USER_INFO}/get-web-preview`,
            {
              entities: allEntities,
            },
          );
          this.urlData = response?.data;
          // console.log({ urlData: this.urlData });
        }
      } catch (error) {
        console.log(error, 'error');
      }
    },
  },
  filters: {
    moment: (date) => moment(date).fromNow(),
  },
};
</script>
